import React from 'react'
import {Tooltip} from 'hec/assets/icons'

const PasswordResetToolTip = () => {
    const listItemClass = 'mb-[0.5rem] ml-3 text-[14px]'
    return (
        <span className="relative group inline-flex items-center">
            <span className="cursor-pointer ml-1" aria-label="Password requirements">
                <Tooltip />
            </span>

            <span
                className="font-normal pointer-events-none absolute bottom-full left-1/2 z-50 ml-1 opacity-0 min-w-[20rem] max-w-[20rem] -translate-x-1/2 -translate-y-[9px] rounded-[0.1875rem] bg-[#444] p-[0.312rem] text-[0.928rem] text-white  shadow-lg transition-opacity duration-500 ease-linear group-hover:block group-hover:opacity-100"
                role="tooltip"
            >
                <ul className="list-disc pl-4 leading-snug mb-0">
                    <li className={`${listItemClass} mt-1`}>
                        Minimum password length: 8 characters
                    </li>
                    <li className={`${listItemClass} `}>Must contain letters</li>
                    <li className={`${listItemClass} `}>Must contain numbers</li>
                    <li className={`${listItemClass} `}>Letters must be mixed case (ex: HsA)</li>
                    <li className="mb-[0.5rem] ml-3 text-[14px]">
                        Minimum of 1 special character ($%/()[]&#123;&#125;=?!.,-_*|+~#)
                    </li>
                </ul>
            </span>
        </span>
    )
}

export default PasswordResetToolTip
